import React from "react";
import { Set } from "immutable";
import { MappedFinancialTarget, TargetGroupWithTargets } from "components/product-collection/footer/types";
import { AllocationBag, AllocationBagType, getBagValuesByRowId } from "helpers/allocation-dimension";

// this hook is just to join every information regarding a target under a single object
export const useTargets = (
    bag: AllocationBag,
    targetGroupsWithTargets: TargetGroupWithTargets[],
    selectedTargetIds: Set<string>
): MappedFinancialTarget[] => {
    const data = React.useMemo(() => {
        return targetGroupsWithTargets.reduce((acc, targetGroup) => {
            const mappedTargets = targetGroup.targets
                .filter((target) => selectedTargetIds.size > 0 && selectedTargetIds.has(target.id))
                .map((target) => {
                    const targetBagValues = getBagValuesByRowId(AllocationBagType.target, bag, target.id).toJS();

                    return {
                        targetId: target.id,
                        targetGroupId: targetGroup.id,
                        budgetTarget: targetGroup.metric,
                        targetGroupName: targetGroup.name,
                        filters: target.filters,
                        values: targetBagValues,
                    };
                });

            return acc.concat(mappedTargets);
        }, []);
    }, [bag, targetGroupsWithTargets, selectedTargetIds]);

    return data;
};
